<template>
  <img @click="goIndex" class="go-index" src="../../images/index.png" v-drag v-show="visible" />
</template>

<script>
let isDrag = false
export default {
  data() {
    return {
      visible: true
    }
  },
  directives: {
    //组建内自定义指令
    drag: {
      // 指令的定义
      bind: function(el, binding) {
        let touch, disX, disY, bodyWidth, bodyHeight
        setTimeout(() => {
          bodyWidth = document.body.clientWidth
          bodyHeight = document.body.clientHeight
        }, 300)
        function limit(num, client) {
          if (num <= 0) return 0
          if (num >= client) return client
          return num
        }
        el.ontouchstart = e => {
          if (e.touches) {
            //有可能对象在e上也有可能对象在e.touches[0]上
            touch = e.touches[0]
          } else {
            touch = e
          }
          disX = touch.clientX - el.offsetLeft //鼠标位置X减去元素距离左边距离（鼠标到元素左边的距离）
          disY = touch.clientY - el.offsetTop //鼠标位置Y减去距离顶部距离（鼠标到元素顶部的高度）
        }
        el.ontouchmove = e => {
          if (e.touches) {
            //有可能对象在e上也有可能对象在e.touches[0]上
            touch = e.touches[0]
          } else {
            touch = e
          }
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          let left = limit(touch.clientX - disX, bodyWidth - 48)
          let top = limit(touch.clientY - disY, bodyHeight - 48)
          //移动当前元素
          el.style.left = left + 'px'
          el.style.top = top + 'px'
          e.preventDefault() //阻止页面的滑动默认事件
        }
        el.ontouchend = e => {
          // el.ontouchmove = null;
          // el.ontouchend = null;
        }
      }
    }
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler (val) {
        this.visible = !['groupIndexHome', 'groupCreateOrder', 'groupQuoteDetail'].includes(val)
      }
    }
  },
  methods: {
    goIndex() {
      this.$router.push({ path: '/group' })
    }
  },
  mounted() {}
}
</script>

<style lang='scss' scoped>
.go-index {
  width: 96px;
  position: absolute;
  left: 20px;
  bottom: 30%;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/group/components/goIndex/index.vue